import React, { Component } from "react";
import { Row, Col, Button, Alert } from "reactstrap";
import { Link } from "react-router-dom";
import { MdArrowBack, MdModeEdit, MdAutorenew } from "react-icons/md";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { idTypeActions } from "./actions/idtypes.actions";

import { Spinner, Placeholder } from "../Shared";
import { routeConstants } from "../../_constants";

export class IdType extends Component {
  componentDidMount() {
    this.getIdType();
  }

  componentWillUnmount() {
    this.props.resetIdType();
  }

  getIdType = () => {
    const { match } = this.props;
    if (match.params && match.params.id) {
      this.props.getIdType(match.params.id);
    }
  };

  render() {
    const { match, response, fetching, error } = this.props;
    const idType = response && response.modelList[0];

    return (
      <div>
        <Row>
          <Col sm="6">
            <Link className="btn btn-outline btn-primary" to={routeConstants.IDTYPES.path}>
              <MdArrowBack /> Back to list
            </Link>
          </Col>
          <Col sm="6">
            <div className="text-right">
              <h5 className="item-count">
                <div>
                  Identification Type: {idType && idType.code}{" "}
                  <Button
                    onClick={this.getIdType}
                    color="primary"
                    outline
                    disabled={fetching}
                  >
                    {fetching ? (
                      <Spinner />
                    ) : (
                      <div>
                        <MdAutorenew size={20} />
                      </div>
                    )}
                  </Button>
                </div>
              </h5>
            </div>
          </Col>
        </Row>
        <hr />
        <Row>
          <Col>
            {error && (
              <Alert color="danger">
                <strong>Error:</strong> {error.message}
              </Alert>
            )}

            <dl className="row">
              {/* <dt className="col-sm-3">Identification Type Id</dt>
              <dd className="col-sm-9">
                {idType ? (
                  idType.id
                ) : (
                  <Placeholder text="Fetching data" blur={3} />
                )}
              </dd> */}

              <dt className="col-sm-3">Identification Type Code</dt>
              <dd className="col-sm-9">
                {idType ? (
                  idType.code
                ) : (
                  <Placeholder text="Fetching data" blur={3} />
                )}
              </dd>

              <dt className="col-sm-3">Identification Type Description</dt>
              <dd className="col-sm-9">
                {idType ? (
                  idType.description
                ) : (
                  <Placeholder text="Fetching data" blur={3} />
                )}
              </dd>
            </dl>
            <Link
              className="btn btn-primary"
              to={`${routeConstants.IDTYPES.path}/edit/${match.params.id}`}
            >
              <MdModeEdit /> Edit
            </Link>
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { fetching, fetched, request, response, error } = state.viewIdType;
  return {
    fetching,
    fetched,
    request,
    response,
    error
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getIdType: bindActionCreators(
      idTypeActions.getIdType,
      dispatch
    ),
    resetIdType: bindActionCreators(
      idTypeActions.resetIdType,
      dispatch
    )
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(IdType);
